<template>
  <div>
    <ul class="list-group list-group-flush scrolling-list">
      <li
        class="list-group-item"
        v-for="service in aggregateOzgTimelineAsServiceList"
        v-bind:key="service.id"
      >
        {{ service.name }}

        <OZGLevelEmoji :level="service.implementationLevel" />
      </li>
    </ul>
  </div>
</template>

<script>
import OZGLevelEmoji from "./../OZGLevelEmoji";

export default {
  name: "OZGActivityServiceList",
  props: [
    "statusType",
    "statusId",
    "serviceId",
    "categoryId",
    "leadingInstitutionID",
    "applicableLaws",
    "showLegend",
    "referenceImplementation"
  ],
  data() {
    return {
      aggregateOzgTimelineAsServiceList: []
    };
  },
  components: { OZGLevelEmoji },

  apollo: {
    $client: "ozgClient",

    aggregateOzgTimelineAsServiceList: {
      query() {
        return require("../../graphql/OZGTimelineMonthStatusUpdateAsServiceList.gql");
      },
      variables: function() {
        return {
          statusId: this.$props.statusId,
          serviceId: this.$props.serviceId,
          categoryId: this.$props.categoryId,
          leadingInstitutionID: this.$props.leadingInstitutionID,
          statusType: this.$props.statusType,
          applicableLaws: this.$props.applicableLaws,
          referenceImplementation: this.$props.referenceImplementation
        };
      }
    }
  }
};
</script>

<style scoped></style>

<style scoped lang="scss">
.scrolling-list {
  max-height: 600px;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.scrolling-list::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.scrolling-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #111111;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.9);
}

.vbt-autcomplete-list {
  border-radius: 0px;

  .list-group-item:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .list-group-item:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}

.list-group-flush > .list-group-item {
  padding-left: 0;
}
</style>
